import React from 'react';
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import IconMessageColumn, { emptyState, normalState } from '../../../components/columns/icon-message-column';
import Global from '../../../store/global-selectors';

import { messages } from '../messages';

const ScanStatusColumn = ({ fulfillmentId }) => {
  const intl = useIntl();
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const verificationStatus =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'verificationStatus',
      }),
    ) || {};
  const { verifiedByGuid, verifiedUtc } = verificationStatus;
  const columnState = verifiedUtc ? normalState : emptyState;
  const userName = useSelector((state) => Global.selectSellerUserById(state, { userId: verifiedByGuid }))?.name;
  const verificationMessage = verifiedByGuid
    ? intl.formatMessage(messages.verifiedBy, { userName })
    : intl.formatMessage(messages.verified);
  return (
    <IconMessageColumn
      date={verifiedUtc}
      icon={faThumbsUp}
      message={<FormattedMessage {...messages.verified} />}
      state={columnState}
      tooltipMessage={verificationMessage}
    />
  );
};

ScanStatusColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const ScanToVerifyStatus = {
  getMessageDescriptor: () => messages.scanToVerifyStatus,
  id: 'scanToVerifyStatus',

  render: (data) => {
    return <ScanStatusColumn fulfillmentId={data.id} />;
  },
};
